import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className={`flex fixed h-screen w-screen z-[100] flex-col items-center justify-center bg-zinc-200 dark:bg-zinc-900 text-center`}>
      <h1 className="text-9xl font-bold text-zinc-700 dark:text-zinc-300">404</h1>
      <p className="mt-4 md:text-2xl text-gray-500 text-xl px-5">
        Oops! The page you're looking for doesn't exist.
      </p>
      <Link to="/" className="mt-6 text-lg text-[#FF785A] font-semibold hover:underline">
        Go Back Home
      </Link>
    </div>
  );
};

export default NotFound;
